import React from "react";
import Notifications from "./Notifications";
import AccountMenu from "./AccountMenu";
import Referral from "./Referral";
import MessagesNotifications from "./MessagesNotifications";
import { ActionsWrapper } from "./styles/actions-styles";
import "semantic-ui-css/components/icon.min.css";
import CurrencyFlag from "./CurrencyFlag";
import { CurrencyCode } from "../../../types/currency";
import { isFeatureEnabled } from "../../../helpers";

type MenuItemIcon = {
  name: string;
};

export type MenuItem = {
  href: string;
  icons: MenuItemIcon[];
  label: string;
};

export type User = {
  avatarUrl: string;
  companyName: string;
  firstName: string;
  fullName: string;
  isEmployer: boolean;
  isPortalEmployer: boolean;
  isPremiumEmployer: boolean;
  isRootParentEmployer: boolean;
  currency: CurrencyCode;
};

type Props = {
  unreadMessages: number;
  unreadNotifications: number;
  messagesUrl: string;
  notificationsUrl: string;
  markAllNotificationsReadUrl: string;
  menuItems: MenuItem[];
  user: User;
};

const Actions = (props: Props): JSX.Element => {
  const {
    unreadMessages,
    unreadNotifications,
    messagesUrl,
    notificationsUrl,
    markAllNotificationsReadUrl,
    menuItems,
    user,
  } = props;

  const { isEmployer, isRootParentEmployer, currency } = user;

  return (
    <ActionsWrapper data-test-id="navbar-actions">
      {isEmployer && !isRootParentEmployer && <Referral user={user} />}
      {!isRootParentEmployer && (
        <>
          <MessagesNotifications
            unreadMessages={unreadMessages}
            messagesUrl={messagesUrl}
          />
          <Notifications
            notificationsUrl={notificationsUrl}
            unreadNotifications={unreadNotifications}
            markAllNotificationsReadUrl={markAllNotificationsReadUrl}
          />
        </>
      )}
      {isFeatureEnabled("currencyFlagInNavbar") && (
        <CurrencyFlag currency={currency} />
      )}
      <AccountMenu user={user} menuItems={menuItems} />
    </ActionsWrapper>
  );
};

export default Actions;
